import { render, staticRenderFns } from "./ResaleSelector.vue?vue&type=template&id=5728d600&scoped=true"
import script from "./ResaleSelector.vue?vue&type=script&lang=js"
export * from "./ResaleSelector.vue?vue&type=script&lang=js"
import style0 from "./ResaleSelector.vue?vue&type=style&index=0&id=5728d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5728d600",
  null
  
)

export default component.exports